import React, { memo } from 'react';
import { Col, Row } from 'reactstrap';
import { TextBlockForm } from './TextBlock';
import { FormInput, FormColorPicker } from '@core/components/form';
import { useNonNilObservable } from '@core/utils/hooks/rxjs';
import { clearPlainTextColors, useOnTextColorChange } from '../Common/TextColors';

export interface TextBlockSettingsProps {
  form: TextBlockForm;
  // Columns of the current variation (1 for the paragraph / heading variations)
  columns?: number;
}

const COLUMNS = [
  { background: 'column1Background', color: 'column1Color', paragraph: 'paragraph' },
  { background: 'column2Background', color: 'column2Color', paragraph: 'paragraph2' },
  { background: 'column3Background', color: 'column3Color', paragraph: 'paragraph3' },
  { background: 'column4Background', color: 'column4Color', paragraph: 'paragraph4' },
] as const;

export const TextBlockSettings = memo((props: TextBlockSettingsProps) => {
  const { form, columns = 4 } = props;
  const formValue = useNonNilObservable(form.value$);

  // A column's new Text Color must show on its text: plain colours typed into that column are cleared (accents stay)
  const clearColumn = (index: number) => {
    const field = COLUMNS[index].paragraph;
    const html = form.controls[field].value || '';
    const cleared = clearPlainTextColors(html);
    if (cleared !== html) form.controls[field].setValue(cleared);
  };
  useOnTextColorChange(formValue.column1Color, () => clearColumn(0));
  useOnTextColorChange(formValue.column2Color, () => clearColumn(1));
  useOnTextColorChange(formValue.column3Color, () => clearColumn(2));
  useOnTextColorChange(formValue.column4Color, () => clearColumn(3));

  return (
    <div>
      <FormInput control={form.controls.columnsWidths} />
      {/* Each column has its own background and text colour; an empty text colour uses the section's Text Color */}
      {COLUMNS.slice(0, Math.max(1, columns)).map(column => (
        <Row key={column.color}>
          <Col>
            <FormColorPicker control={form.controls[column.background]} />
          </Col>
          <Col>
            <FormColorPicker control={form.controls[column.color]} />
          </Col>
        </Row>
      ))}
    </div>
  );
});
